import { pdsLogger } from '../../pds-logger';
let log = pdsLogger.requiresLogger('gridWidget');

export let gridWidgetLogger = {
  log(message, color): void {
    if (color != null) {
      log('%c' + message, 'color: ' + color);
    } else {
      log(message);
    }
  }
};
